import React from "react";
import reviewer1 from "../assets/images/reviewer1.jpeg";
import Erin from "../assets/images/review6.JPG";
import Wally from "../assets/images/review5.jpeg";
import NanaPapa from "../assets/images/review7.jpeg";
import Julie from "../assets/images/review3.JPG";
import GrandmaKeith from "../assets/images/review8.JPG";

function Reviews() {
  const reviews = [
    {
      id: 1,
      name: "Mom",
      image: Erin,
      quote: "I couldn’t be more proud of the wonderful person Millie is. She is sweet, observant, and full of kindness — always thinking of others and bringing such warmth to every moment. She has this beautiful way of making people feel seen and valued, and her love for family and friends shines in everything she does. Millie embraces life with curiosity and courage, always eager to try new things and explore new places. She fills each day with joy, laughter, and love, and I feel so grateful to be her mom."
    }, 
    {
      id: 2, 
      name: "Dad", 
      image: Wally, 
      quote: "Millie- your perseverance, hope, and joy in each and every day are a light in this world for all to witness, behold, and find inspiration"
    }, 
    { 
      id: 3, 
      name: "Nana & Papa", 
      image: NanaPapa,
      quote: "We love Millie’s happy smile and her enthusiasm and joy. She makes us happy! Millie brightens the room when she walks into it! We love that her favorite color is orange! Such a happy color like her! "
    }, 
    {
      id: 6,
      name: "Grandma & Keith", 
      image: GrandmaKeith,
      quote: "Millie is a ray of sunshine in our lives. Her joyful spirit and loving heart make every moment special. We cherish the time we spend together and are so proud of the amazing person she is becoming."

    },
    { 
      id: 4, 
      name: "Aunt Julie", 
      image: Julie,
      quote: "Millie makes me happy when I am sad.  There is no one I’d rather shop at Target with. She is joy personified"
    },
    {
      id: 5,
      name: "Uncle Robbie & Aunt Liz",
      image: reviewer1,
      quote: "We love hanging out with Millie!! She is always ready for an adventure and is full of joy. 💛",
    }
  ];

  return (
    <div className="pt-16 px-6 max-w-6xl mx-auto">
  <h2 className="text-3xl font-bold text-yellow-700 mb-6 text-center">
    What People Say About Millie ⭐
  </h2>

  {/* Horizontal scroll container */}
  <div className="overflow-x-auto pb-4">
    <div className="flex gap-6 snap-x snap-mandatory">
      {reviews.map((review) => (
        <div key={review.id} className="snap-start min-w-[280px] sm:min-w-[340px] max-w-[360px]">
          <div className="h-[420px] bg-white/85 backdrop-blur rounded-2xl shadow-lg p-6 flex flex-col items-center text-center hover:shadow-2xl transition-shadow duration-300 border border-white/40">
            <img
              src={review.image}
              alt={review.name}
              loading="lazy"
              className="w-24 h-24 rounded-full object-cover mb-4 shadow-md"
            />

            {/* Quote area (scrolls if long) */}
            <div className="flex-1 w-full overflow-y-auto px-1">
              <p className="text-gray-800 italic leading-relaxed">
                “{review.quote}”
              </p>
            </div>

            <span className="font-semibold text-yellow-700 mt-4">
              {review.name}
            </span>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

  );
}

export default Reviews;
